import { defineComponent as _defineComponent } from 'vue'
import { toRefs, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    isLoading: { type: Boolean, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  isLoading: boolean;
}

const isDnone = ref(true);

const Props = toRefs(props);

/** バックエンドとの通信中にローディング画面を表示 */
watch(
  () => Props.isLoading.value,
  function () {
    if (Props.isLoading.value) {
      isDnone.value = false;
    } else {
      isDnone.value = true;
    }
  }
);

const __returned__ = { isDnone, props, Props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})